// ***************************************
// Definition of game token ParticleEffect
// ***************************************
import { tbGame } from "../engine/tbGame";
import { tbParticle } from "../engine/tbParticle";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { getContainerForLayer, Layer } from "./SceneController";
// The constructor for the ParticleEffect game token. 
export var ParticleEffect = function (x, y, properties, container) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    this.container = container ? container : getContainerForLayer(Layer.particle);
    this.extraScale = properties.scale ? properties.scale : 0;
    this.particles = properties.particle;
    this.images = properties.images;
    this.particle = null;
    // Your own properties
    this.x = x;
    this.y = y;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
ParticleEffect.prototype.handleAdd = function () {
    "use strict";
    var self = this, scale = (1 / PhysicsSettings.textureResolution), effectScale = scale + this.extraScale;
    this.particle = new tbParticle(this.container, this.particles, this.images);
    this.particle.setCallback(function () {
        tbGame.removeToken(self);
    });
    this.particle.setScale(effectScale);
    this.particle.setPosition(this.x, this.y);
    this.particle.show();
};
ParticleEffect.prototype.move = function (x, y) {
    "use strict";
    // this.particle.setMove(x, y);
};
ParticleEffect.prototype.createNew = function () {
    "use strict";
    //new ParticleEffect(this.container);
};
// handleRemove is called when the token is removed from the game.
ParticleEffect.prototype.handleRemove = function () {
    "use strict";
    this.particle.destroy();
};
// handleBeginStep is called each step before processing other events.
ParticleEffect.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    this.particle.update(timePassed);
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
ParticleEffect.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
ParticleEffect.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
ParticleEffect.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
ParticleEffect.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
ParticleEffect.prototype.handleEndStep = function (timePassed) {
    "use strict";
};
// handleDraw is called at the end of a step to draw the token.
ParticleEffect.prototype.handleDraw = function () {
    "use strict";
};
